export default "__VITE_ASSET__d5d4e28f__"